import { apiV2Root } from "consts";
import { useDataQueryParams } from "hooks/useDataQueryParams";

export type ContentUrlCheck = { ok: boolean; statusCode: number | null };

export const usePageContentCheck = (
  pageId: number | undefined,
): ContentUrlCheck | undefined =>
  useDataQueryParams<ContentUrlCheck>(
    `pages/${pageId}/content-check/`,
    {},
    apiV2Root,
    !pageId,
  );
